/* eslint-disable no-unused-vars */
import React, { useCallback, useEffect, useRef, useState } from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';

export function ZetaSection(props) {
  const activeSection = (props.app && props.app.activeSection) || props.activeSection || '';
  const { name, size, maxWidth } = props;
  const allowPrint = props.allowPrint || false;

  let divColumnClass;
  switch(size || '') {
    case 'max':
      divColumnClass = '';
      break;

    default:
      divColumnClass = 'col-lg-12 col-xl-10 offset-xl-1';
  }

  let cardStyle = {};
  if (maxWidth && maxWidth!=='') {
    cardStyle = {
      maxWidth: maxWidth,
      display: 'block',
      marginLeft: 'auto',
      marginRight: 'auto',
    }
  }

  let hidden = false;
  if (name && activeSection && name !== activeSection) hidden = true;

  return (
    <div id={props.id} className={'row ' + (allowPrint ? '' : 'no-print ')  + (hidden ? ' d-none' : '') + ` ${props.className || ''}`}>
      <div className={`col ${divColumnClass}`}>
        <div className={"card " + (maxWidth!=='' ? '' : 'm-2')} style={cardStyle}>
          {props?.title && props.title!=='' && <div className="card-header">
            <h6 className="m-0 font-weight-bold text-primary">{props.title}</h6>
          </div>}

          <div className="card-body">{props.children}</div>
        </div>
      </div>
    </div>
  );
}

ZetaSection.propTypes = {
  app: PropTypes.any,
  activeSection: PropTypes.string,
  id: PropTypes.string,
  name: PropTypes.string,
  title: PropTypes.string,
  children: PropTypes.any,
  className: PropTypes.string,
  size: PropTypes.string,
  maxWidth: PropTypes.string,
  allowPrint: PropTypes.bool,
}